import { Controller } from "@hotwired/stimulus"

import Inputmask from "inputmask"

// Connects to data-controller="address"
export default class extends Controller {
  static targets = ['zipcode', 'street', 'neighborhood', 'city']

  connect() {
    Inputmask(this.zipcodeTarget.dataset.mask).mask(this.zipcodeTarget)
  }

  zipcode_blur() {
    if (this.zipcodeTarget.value.length === 9) {
      $.post("/utils/zipcode", { zipcode: this.zipcodeTarget.value }, (data) => {
        if (data) {
          this.streetTarget.value = data.data.street
          this.neighborhoodTarget.value = data.data.neighborhood
          if (data.city) {
            const citySelect = this.cityTarget.tomselect
            citySelect.clearOptions()
            citySelect.addOption({
              id: data.city.id,
              name: data.city.name,
            })
            citySelect.setValue(data.city.id)
          }
        }
      })
    } else {
      alert('CEP inválido')
    }
  }
}
